import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { map } from 'rxjs/operators'
import { Observable } from 'rxjs'
import { Category } from '../models/Category'
import { SubCategory } from '../models/SubCategory'
import { Alternative } from '../models/Alternative'
import { PATH } from '../app.api'
import { BotanicClassification } from '../models/BotanicClassification'
import { ICategoryTree } from '../models/CategoryTree'

@Injectable()
export class BotanicService {
	constructor(private http: HttpClient) {}

	public getClass(): Observable<Array<BotanicClassification>> {
		const options = this.setHeader()

		return this.http
			.get<any>(`${PATH}/botanicClassification`, { headers: options })
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public getClassFormated(): Observable<Array<ICategoryTree>> {
		const options = this.setHeader()

		return this.http
			.get<any>(`${PATH}/botanicClassification?format=true`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public getCategories(): Observable<Array<Category>> {
		const options = this.setHeader()
		return this.http
			.get<any>(PATH + '/botanicClassification/category', { headers: options })
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public getSubCategories(id: string): Observable<Array<SubCategory>> {
		const options = this.setHeader()
		return this.http
			.get<any>(`${PATH}/botanicClassification/subCategory/${id}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public addCategory(category: Category): Observable<any> {
		const options = this.setHeader()
		return this.http.post<any>(
			PATH + '/botanicClassification/category',
			JSON.stringify(category),
			{ headers: options }
		)
	}

	public addSubCategory(subCategory: SubCategory): Observable<any> {
		const options = this.setHeader()
		return this.http.post<any>(
			PATH + '/botanicClassification/subCategory',
			JSON.stringify(subCategory),
			{ headers: options }
		)
	}

	public addAlternative(alternative: Alternative): Observable<any> {
		const options = this.setHeader()
		return this.http.post<any>(
			PATH + '/botanicClassification/alternative',
			JSON.stringify(alternative),
			{ headers: options }
		)
	}

	public removeClass(id: string): Observable<any> {
		const options = this.setHeader()
		return this.http.delete<any>(PATH + `/botanicClassification/${id}`, {
			headers: options
		})
	}

	public removeSub(id: string): Observable<any> {
		const options = this.setHeader()
		return this.http.delete<any>(
			PATH + `/botanicClassification/subCategory/${id}`,
			{ headers: options }
		)
	}

	public removeCat(id: string): Observable<any> {
		const options = this.setHeader()
		return this.http.delete<any>(
			PATH + `/botanicClassification/category/${id}`,
			{ headers: options }
		)
	}

	private setHeader() {
		const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
		const options = headers
		return options
	}
}
